const NET_INTERRUPTED_ERROR_RETRY = 3;  // 用于由于切后台造成的下载失败最大重试次数

class Loader {
    constructor(
        list = [],
        { onProgress = null, onSuccess = null, onFailure = null, autoRetry = 1 } = {}
    ) {
        this.list = list
        this.onProgress = onProgress
        this.onSuccess = onSuccess
        this.onFailure = onFailure
        this.autoRetry = Math.max(0, autoRetry);
        this._retryCount = 0;
        this._interruptedRetryCount = 0;    // 切后台造成的下载失败单独计算重试次数
        this.loaded = 0
        this.total = 0
        this.errorList = []
    }

    add(resource) {
        this.list.push(resource)
    }

    get total() {
        return this.list.length
    }

    get percent() {
        return this.loaded / this.list.length * 100
    }

    _load(list) {
        let loaderList = []
        let funcList = []
        list.forEach(item => {
            if (typeof item === 'string') {
                loaderList.push(item)
            } else if (typeof item === 'function') {
                funcList.push(item)
            } else {
                cc.warn('SmartLoader:', 'unknown resource type in load list')
            }
        })
        let loadPromise = new Promise((resolve, reject) => {
            cc.loader.load(loaderList, {
                trigger: (data, size, finishedSize) => {
                    if (data) {
                        this.loaded++
                        this.onProgress && this.onProgress.call(this, data)
                    }
                },
                cb: (err, results) => {
                    if (cc.sys.platform === cc.sys.WECHAT_GAME) {
                        // 无论成功失败，手动存储cache
                        wxCache.saveToStorage()
                        /*wxCache.saveToStorageAsync().then(()=>{
                            if (err) {
                                this.errorList = []
                                err.forEach((v, index) => {
                                    this.errorList.push(loaderList[index])
                                })
                                cc.warn('Loader: load error', this.errorList, err)
                                if (this.errorList.length > 0) {
                                    reject(err, this.errorList)
                                }
                            } else {
                                cc.log("[####]savestoryge success ", results)
                                resolve(results)
                            }
                        }).catch(()=>{console.error("savetostorageasync error")})*/
                    }
                    //else{
                        if (err) {
                            this.errorList = []
                            err.forEach((v, index) => {
                                this.errorList.push(loaderList[index])
                            })
                            cc.warn('Loader: load error', this.errorList, err)
                            let errMsg = "[SmartLoader] load failed.error=" +JSON.stringify(err) + ";errList="+JSON.stringify(this.errorList);
                            window.logCenter && logCenter.warn(new Error(errMsg), 'SmartLoaderError');
                            reject(err, this.errorList);
                        } else {
                            resolve(results)
                        }
                    //}
                }
            })
        })
        let funcPromises = []
        funcList.forEach(func => {
            let promise = func()
            if (promise instanceof Promise) {
                funcPromises.push(promise.then(() => {
                    this.loaded++
                    this.onProgress && this.onProgress.call(this)
                }).catch(e => {
                    cc.log(e)
                    this.errorList.push(func)
                    return Promise.reject(e)
                }))
            } else {
                cc.warn('SmartLoader:', 'function in load list should return a Promise')
            }
        })
        return Promise.all([loadPromise, ...funcPromises]).then(res => {
            cc.log('SmartLoader:', 'load success', res)
            this.onSuccess && this.onSuccess.call(this, this.list)
            return res
        }).catch(e => {
            console.warn("SmartLoader: load failed.",e, this.errorList);
            if (this.errorList.length > 0) {
            // 因为游戏切换到后台导致的错误允许自动重试, 不扣除重试次数
                if (IsNetInterruptedError(e) && this._interruptedRetryCount < NET_INTERRUPTED_ERROR_RETRY) {
                    console.log("SmartLoader: net interrupted happened. loader will retry in next frame");
                    // 切到后台引擎暂停，等待引擎重新启动，下一帧重试
                    return new Promise(resolve=> {
                        setCCTimeOut(resolve, 0);
                    }).then(()=> {
                        return this.retry(true);
                    });
                } else if (this._retryCount < this.autoRetry) {
                    return this.retry();
                }
            }
                
            this.onFailure && this.onFailure.call(this, e, this.errorList)
            return Promise.reject(e, this.errorList);
        })
    }

    load() {
        this.errorList = []
        this.loaded = 0
        this.total = this.list.length
        cc.log('loader load', this.list)
        return this._load(this.list)
    }

    retry(interruptedError = false) {
        cc.warn('loader retry', this.errorList)
        if (interruptedError) {
            this._interruptedRetryCount++;
        } else {
            this._retryCount++;
        }

        return this._load(this.errorList)
    }
}

Loader.create = function(...args) {
    return new Loader(...args)
}
SmartLoader = Loader


/**
是否因为小游戏切到后台导致了下载失败
https://developers.weixin.qq.com/minigame/dev/guide/base-ability/network.html
 */
function IsNetInterruptedError(e) {
    if (!e)
        return false;
    let str = JSON.stringify(e);
    return str && str.indexOf('network api interrupted in suspend state') > 0;
}
export default SmartLoader
